// extracted by mini-css-extract-plugin
export default {"icon":"percent-circular-progress_icon__HABGy","circularContainer":"percent-circular-progress_circularContainer__FPXsg","processChild":"percent-circular-progress_processChild__VZydl"};